"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftGroupingCategoryToJSON = exports.NftGroupingCategoryFromJSONTyped = exports.NftGroupingCategoryFromJSON = void 0;
var runtime_1 = require("../runtime");
function NftGroupingCategoryFromJSON(json) {
    return NftGroupingCategoryFromJSONTyped(json, false);
}
exports.NftGroupingCategoryFromJSON = NftGroupingCategoryFromJSON;
function NftGroupingCategoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'priority': !(0, runtime_1.exists)(json, 'priority') ? undefined : json['priority'],
    };
}
exports.NftGroupingCategoryFromJSONTyped = NftGroupingCategoryFromJSONTyped;
function NftGroupingCategoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'name': value.name,
        'description': value.description,
        'priority': value.priority,
    };
}
exports.NftGroupingCategoryToJSON = NftGroupingCategoryToJSON;
